import {Card} from "../../../../../components/card/card.jsx";
import TotalPassagesCard from "./total-passages-card.jsx";
import MapPassagesCard from "./map-passages-card.jsx";

export default function VehiclePassagesCard({ passagesData }) {
    return (
        <Card className="dash-main-card col-span-29 row-span-1 min-h-0 min-w-0">
            <Card.Header className="border-b-0! bg-transparent!">
                <Card.Title className="bg-transparent text-[#F4FFFF] text-center w-full text-(length:--font-lg)!">
                    Passagens de veículos
                </Card.Title>
            </Card.Header>
            <Card.Body className="flex-1 min-h-0 flex px-(--dash-pad-md)! pb-(--dash-pad-md)!">
                <section className="flex-1 w-full min-h-0 min-w-0 grid grid-cols-[minmax(0,556fr)_minmax(0,554fr)] gap-x-[20px]">
                    <TotalPassagesCard passages={passagesData} />

                    <MapPassagesCard capturePlaces={passagesData} />
                </section>
            </Card.Body>
        </Card>
    )
}
